import React from "react"
import { OldButton } from "@kit/design/old-button"
import { analytics } from "utils/analytics"

const trackClick = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      name: "header_upgrade_now",
      text: "Upgrade now"
    },
    { transport: "beacon" }
  )
}

export function TrialNav({ userInfo, daysLeft }) {
  const showCountdown = userInfo.trialing
  const showUpgradeButton = userInfo.trialing

  return (
    <React.Fragment>
      <div className="flex items-center">
        {showCountdown && (
          <div className="my-auto mx-5 text-black">
            Trial: {daysLeft} remaining
          </div>
        )}

        {showUpgradeButton && (
          <OldButton
            is="primary"
            size="sm"
            href="/upgrade"
            onClick={trackClick}
          >
            Upgrade
          </OldButton>
        )}
      </div>
    </React.Fragment>
  )
}
